export default "__VITE_ASSET__1b499f88__"